module.exports = __webpack_public_path__ + "es.svg?04082ad4b86605f42ec0447c354b62f9";